import MenuFrame from "../frames/menu_frame";

function VendorPage() {
    return (
        <MenuFrame>
            VendorPage
        </MenuFrame>
    );
}

export default VendorPage;
